import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'
import shape from '../../assets/images/shape/shape1.svg'

const TestimonialsStyleTwo = () => {
  const { testimonials } = useStaticQuery(
    graphql`
      query {
        testimonials: allContentfulTestimonials(
          limit: 4
          sort: { fields: createdAt, order: DESC }
        ) {
          edges {
            node {
              name
              position
              image {
                fluid(maxWidth: 51) {
                  src
                }
              }
              quote
            }
          }
        }
      }
    `
  )

  if (!testimonials) {
    return null
  }

  return (
    <div className="testimonials-area pt-100 pb-70 bg-fafafb">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="about" />
            Testimonials
          </span>
          <h2>What Our Clients are Saying?</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p>
        </div>

        <div className="row">
          {testimonials.edges.map((testi, index) => {
            return (
              <div key={index} className="col-lg-6 col-md-6">
                <div className="single-testimonials-box">
                  <img
                    src={testi.node.image.fluid.src}
                    className="shadow-sm"
                    alt="client"
                  />
                  <p>{testi.node.quote}</p>
                  <div className="client-info">
                    <h3>{testi.node.name}</h3>
                    <span>{testi.node.position}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className="shape-img1">
        <img src={shape} alt="about" />
      </div>
    </div>
  )
}

export default TestimonialsStyleTwo
